"use strict";
/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten
Object.defineProperty(exports, "__esModule", { value: true });
exports.stacksByVaultId = exports.membershipsByVaultId = exports.membershipsByEmail = exports.membershipsByAddress = exports.listKeyMetrics = exports.getKeyMetric = exports.listWebhookLogs = exports.getWebhookLog = exports.listWebhooks = exports.getWebhook = exports.listApiKeys = exports.getApiKey = exports.listOrganisations = exports.getOrganisation = exports.listPaymentTransactions = exports.getPaymentTransaction = exports.listUtokens = exports.getUtoken = exports.listStorages = exports.getStorage = exports.listUsers = exports.getUser = exports.listNotifications = exports.getNotification = exports.listTransactionLogs = exports.getTransactionLog = exports.listTransactions = exports.getTransaction = exports.listStorageTransactions = exports.getStorageTransaction = exports.listBundles = exports.getBundle = exports.listWhitelists = exports.getWhitelist = exports.listMemos = exports.getMemo = exports.listFolders = exports.getFolder = exports.listFileVersions = exports.getFileVersion = exports.listCollections = exports.getCollection = exports.listNFTS = exports.getNFT = exports.listStacks = exports.getStack = exports.listMemberships = exports.getMembership = exports.listVaults = exports.getVault = void 0;
exports.keyMetricsByDate = exports.webhookLogsByAddressAndCreatedAt = exports.organisationsByEmail = exports.organisationsByOwner = exports.organisationsBySubdomain = exports.paymentTransactionsByStatusAndCreatedAt = exports.usersByOrgId = exports.usersByReferralId = exports.usersByEmail = exports.notificationsByToAddressAndUpdatedAt = exports.transactionLogsByOwner = exports.transactionsByVaultId = exports.storageTransactionsByStatusAndCreatedAt = exports.storageTransactionsByBundleId = exports.storageTransactionsByDataItemId = exports.storageTransactionsByTxId = exports.storageTransactionsByOwnerAndCreatedAt = exports.bundlesByStatusAndCreatedAt = exports.bundlesByTxId = exports.whitelistsByOwner = exports.whitelistsByVaultId = exports.memosByVaultId = exports.foldersByParentId = exports.foldersByVaultId = exports.fileVersionsByOwnerAndCreatedAt = exports.fileVersionsByNodeIdAndCreatedAt = exports.collectionsByParentId = exports.collectionsByVaultId = exports.nFTSByParentIdAndName = exports.nFTSByVaultIdAndName = exports.stacksByParentId = void 0;
exports.getVault = `query GetVault($id: ID!) {
  getVault(id: $id) {
    id
    membership {
      items {
        id
        address
        email
        vaultId
        vault {
          id
          membership {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          admin
          data
          description
          name
          owner
          public
          cloud
          blocked
          size
          status
          tags
          termsOfAccess
          createdAt
          updatedAt
          __typename
        }
        memberDetails {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        data
        expiresAt
        _ttl
        keys {
          encPrivateKey
          encPublicKey
          publicKey
          __typename
        }
        encPublicSigningKey
        message
        owner
        role
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    admin
    data
    description
    name
    owner
    public
    cloud
    blocked
    size
    status
    tags
    termsOfAccess
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.listVaults = `query ListVaults(
  $filter: ModelVaultFilterInput
  $limit: Int
  $nextToken: String
) {
  listVaults(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      membership {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      admin
      data
      description
      name
      owner
      public
      cloud
      blocked
      size
      status
      tags
      termsOfAccess
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getMembership = `query GetMembership($id: ID!) {
  getMembership(id: $id) {
    id
    address
    email
    vaultId
    vault {
      id
      membership {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      admin
      data
      description
      name
      owner
      public
      cloud
      blocked
      size
      status
      tags
      termsOfAccess
      createdAt
      updatedAt
      __typename
    }
    memberDetails {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    data
    expiresAt
    _ttl
    keys {
      encPrivateKey
      encPublicKey
      publicKey
      __typename
    }
    encPublicSigningKey
    message
    owner
    role
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.listMemberships = `query ListMemberships(
  $filter: ModelMembershipFilterInput
  $limit: Int
  $nextToken: String
) {
  listMemberships(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      address
      email
      vaultId
      vault {
        id
        membership {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        admin
        data
        description
        name
        owner
        public
        cloud
        blocked
        size
        status
        tags
        termsOfAccess
        createdAt
        updatedAt
        __typename
      }
      memberDetails {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      data
      expiresAt
      _ttl
      keys {
        encPrivateKey
        encPublicKey
        publicKey
        __typename
      }
      encPublicSigningKey
      message
      owner
      role
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getStack = `query GetStack($id: ID!) {
  getStack(id: $id) {
    id
    versions {
      items {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    vaultId
    parentId
    name
    owner
    status
    data
    tags
    size
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.listStacks = `query ListStacks(
  $filter: ModelStackFilterInput
  $limit: Int
  $nextToken: String
) {
  listStacks(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      versions {
        items {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      vaultId
      parentId
      name
      owner
      status
      data
      tags
      size
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getNFT = `query GetNFT($id: ID!) {
  getNFT(id: $id) {
    id
    vaultId
    parentId
    name
    owner
    assetId
    asset {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    thumbnailId
    thumbnail {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    balances
    claimable {
      from
      qty
      to
      txID
      __typename
    }
    creator
    ticker
    description
    collection
    data
    status
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.listNFTS = `query ListNFTS($filter: ModelNFTFilterInput, $limit: Int, $nextToken: String) {
  listNFTS(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      vaultId
      parentId
      name
      owner
      assetId
      asset {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      thumbnailId
      thumbnail {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      balances
      claimable {
        from
        qty
        to
        txID
        __typename
      }
      creator
      ticker
      description
      collection
      data
      status
      tags
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getCollection = `query GetCollection($id: ID!) {
  getCollection(id: $id) {
    id
    vaultId
    parentId
    name
    description
    owner
    bannerId
    banner {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    thumbnailId
    thumbnail {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    code
    creator
    items
    type
    ucm
    udl {
      commercialUses {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      currency
      derivations {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      dataModelTrainings {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      expires
      license
      licenseFee {
        type
        value
        __typename
      }
      paymentAddress
      paymentMode
      unknownUsageRights
      __typename
    }
    data
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.listCollections = `query ListCollections(
  $filter: ModelCollectionFilterInput
  $limit: Int
  $nextToken: String
) {
  listCollections(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      vaultId
      parentId
      name
      description
      owner
      bannerId
      banner {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      thumbnailId
      thumbnail {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      code
      creator
      items
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      data
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getFileVersion = `query GetFileVersion($id: ID!) {
  getFileVersion(id: $id) {
    id
    nodeId
    owner
    storageTransactionId
    storageTransaction {
      id
      owner
      txId
      txFee
      dataItemId
      fileVersion {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      bundleId
      bundle {
        id
        txId
        txFee
        status
        dataItem {
          items {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        uploadCount
        dataItemsCount
        size
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      members {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      class
      vaultId
      nodeId
      nodeType
      status
      type
      uploadCount
      size
      verificationId
      verificationCount
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    name
    chunkSize
    numberOfChunks
    resourceUri
    size
    type
    ucm
    udl {
      commercialUses {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      currency
      derivations {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      dataModelTrainings {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      expires
      license
      licenseFee {
        type
        value
        __typename
      }
      paymentAddress
      paymentMode
      unknownUsageRights
      __typename
    }
    status
    external
    nodeType
    tags
    class
    _ttl
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.listFileVersions = `query ListFileVersions(
  $filter: ModelFileVersionFilterInput
  $limit: Int
  $nextToken: String
) {
  listFileVersions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getFolder = `query GetFolder($id: ID!) {
  getFolder(id: $id) {
    id
    vaultId
    parentId
    data
    name
    owner
    size
    status
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.listFolders = `query ListFolders(
  $filter: ModelFolderFilterInput
  $limit: Int
  $nextToken: String
) {
  listFolders(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      vaultId
      parentId
      data
      name
      owner
      size
      status
      tags
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getMemo = `query GetMemo($id: ID!) {
  getMemo(id: $id) {
    id
    vaultId
    data
    owner
    status
    versions {
      message
      owner
      reactions {
        owner
        reaction
        createdAt
        __typename
      }
      attachments
      createdAt
      __typename
    }
    parentId
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.listMemos = `query ListMemos(
  $filter: ModelMemoFilterInput
  $limit: Int
  $nextToken: String
) {
  listMemos(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      vaultId
      data
      owner
      status
      versions {
        message
        owner
        reactions {
          owner
          reaction
          createdAt
          __typename
        }
        attachments
        createdAt
        __typename
      }
      parentId
      tags
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getWhitelist = `query GetWhitelist($id: ID!) {
  getWhitelist(id: $id) {
    id
    vaultId
    owner
    type
    token
    capacity
    access
    members {
      address
      email
      externalAddress
      __typename
    }
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.listWhitelists = `query ListWhitelists(
  $filter: ModelWhitelistFilterInput
  $limit: Int
  $nextToken: String
) {
  listWhitelists(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      vaultId
      owner
      type
      token
      capacity
      access
      members {
        address
        email
        externalAddress
        __typename
      }
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getBundle = `query GetBundle($id: ID!) {
  getBundle(id: $id) {
    id
    txId
    txFee
    status
    dataItem {
      items {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    uploadCount
    dataItemsCount
    size
    signedBy
    signature
    payedBy
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.listBundles = `query ListBundles(
  $filter: ModelBundleFilterInput
  $limit: Int
  $nextToken: String
) {
  listBundles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      txId
      txFee
      status
      dataItem {
        items {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      uploadCount
      dataItemsCount
      size
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getStorageTransaction = `query GetStorageTransaction($id: ID!) {
  getStorageTransaction(id: $id) {
    id
    owner
    txId
    txFee
    dataItemId
    fileVersion {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    bundleId
    bundle {
      id
      txId
      txFee
      status
      dataItem {
        items {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      uploadCount
      dataItemsCount
      size
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    members {
      items {
        id
        address
        email
        vaultId
        vault {
          id
          membership {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          admin
          data
          description
          name
          owner
          public
          cloud
          blocked
          size
          status
          tags
          termsOfAccess
          createdAt
          updatedAt
          __typename
        }
        memberDetails {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        data
        expiresAt
        _ttl
        keys {
          encPrivateKey
          encPublicKey
          publicKey
          __typename
        }
        encPublicSigningKey
        message
        owner
        role
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    class
    vaultId
    nodeId
    nodeType
    status
    type
    uploadCount
    size
    verificationId
    verificationCount
    signedBy
    signature
    payedBy
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.listStorageTransactions = `query ListStorageTransactions(
  $filter: ModelStorageTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  listStorageTransactions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      txId
      txFee
      dataItemId
      fileVersion {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      bundleId
      bundle {
        id
        txId
        txFee
        status
        dataItem {
          items {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        uploadCount
        dataItemsCount
        size
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      members {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      class
      vaultId
      nodeId
      nodeType
      status
      type
      uploadCount
      size
      verificationId
      verificationCount
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getTransaction = `query GetTransaction($id: ID!) {
  getTransaction(id: $id) {
    id
    txId
    function
    owner
    vaultId
    actionRef
    groupRef
    objectId
    objectType
    data
    input
    referrer
    status
    tags
    cloud
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.listTransactions = `query ListTransactions(
  $filter: ModelTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  listTransactions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      txId
      function
      owner
      vaultId
      actionRef
      groupRef
      objectId
      objectType
      data
      input
      referrer
      status
      tags
      cloud
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getTransactionLog = `query GetTransactionLog($id: ID!) {
  getTransactionLog(id: $id) {
    id
    owner
    actionRef
    admin
    content
    vaultId
    groupRef
    hash
    objectId
    objectType
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.listTransactionLogs = `query ListTransactionLogs(
  $filter: ModelTransactionLogFilterInput
  $limit: Int
  $nextToken: String
) {
  listTransactionLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      actionRef
      admin
      content
      vaultId
      groupRef
      hash
      objectId
      objectType
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getNotification = `query GetNotification($id: ID!) {
  getNotification(id: $id) {
    id
    fromAddress
    from {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    toAddress
    to {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    toMemberId
    toMember {
      id
      address
      email
      vaultId
      vault {
        id
        membership {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        admin
        data
        description
        name
        owner
        public
        cloud
        blocked
        size
        status
        tags
        termsOfAccess
        createdAt
        updatedAt
        __typename
      }
      memberDetails {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      data
      expiresAt
      _ttl
      keys {
        encPrivateKey
        encPublicKey
        publicKey
        __typename
      }
      encPublicSigningKey
      message
      owner
      role
      status
      createdAt
      updatedAt
      __typename
    }
    toEmail
    vaultId
    vault {
      id
      membership {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      admin
      data
      description
      name
      owner
      public
      cloud
      blocked
      size
      status
      tags
      termsOfAccess
      createdAt
      updatedAt
      __typename
    }
    objectId
    objectType
    objectName
    event
    channels
    content
    status
    priority
    activity
    admin
    count
    host
    _ttl
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.listNotifications = `query ListNotifications(
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      fromAddress
      from {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      toAddress
      to {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      toMemberId
      toMember {
        id
        address
        email
        vaultId
        vault {
          id
          membership {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          admin
          data
          description
          name
          owner
          public
          cloud
          blocked
          size
          status
          tags
          termsOfAccess
          createdAt
          updatedAt
          __typename
        }
        memberDetails {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        data
        expiresAt
        _ttl
        keys {
          encPrivateKey
          encPublicKey
          publicKey
          __typename
        }
        encPublicSigningKey
        message
        owner
        role
        status
        createdAt
        updatedAt
        __typename
      }
      toEmail
      vaultId
      vault {
        id
        membership {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        admin
        data
        description
        name
        owner
        public
        cloud
        blocked
        size
        status
        tags
        termsOfAccess
        createdAt
        updatedAt
        __typename
      }
      objectId
      objectType
      objectName
      event
      channels
      content
      status
      priority
      activity
      admin
      count
      host
      _ttl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getUser = `query GetUser($address: String!) {
  getUser(address: $address) {
    address
    email
    referralId
    avatar
    profileName
    publicKey
    publicSigningKey
    metadata
    orgId
    orgRole
    _ttl
    createdAt
    updatedAt
    organisationUsersId
    __typename
  }
}
`;
exports.listUsers = `query ListUsers(
  $address: String
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listUsers(
    address: $address
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getStorage = `query GetStorage($address: String!) {
  getStorage(address: $address) {
    address
    cloud_audio
    cloud_documents
    cloud_notes
    cloud_other
    cloud_photos
    cloud_storage_available
    cloud_storage_total
    cloud_video
    audio
    documents
    notes
    other
    photos
    video
    storage_available
    storage_total
    u_balance
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.listStorages = `query ListStorages(
  $address: String
  $filter: ModelStorageFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listStorages(
    address: $address
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      address
      cloud_audio
      cloud_documents
      cloud_notes
      cloud_other
      cloud_photos
      cloud_storage_available
      cloud_storage_total
      cloud_video
      audio
      documents
      notes
      other
      photos
      video
      storage_available
      storage_total
      u_balance
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getUtoken = `query GetUtoken($address: String!) {
  getUtoken(address: $address) {
    address
    balance
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.listUtokens = `query ListUtokens(
  $address: String
  $filter: ModelUtokenFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listUtokens(
    address: $address
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      address
      balance
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getPaymentTransaction = `query GetPaymentTransaction($paymentIntentId: String!) {
  getPaymentTransaction(paymentIntentId: $paymentIntentId) {
    cart {
      amount
      currency
      priceId
      productId
      promo
      storage
      __typename
    }
    createdAt
    invoiceNumber
    paidAt
    paymentIntentId
    owner
    receiptNumber
    status
    updatedAt
    __typename
  }
}
`;
exports.listPaymentTransactions = `query ListPaymentTransactions(
  $paymentIntentId: String
  $filter: ModelPaymentTransactionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPaymentTransactions(
    paymentIntentId: $paymentIntentId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      cart {
        amount
        currency
        priceId
        productId
        promo
        storage
        __typename
      }
      createdAt
      invoiceNumber
      paidAt
      paymentIntentId
      owner
      receiptNumber
      status
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getOrganisation = `query GetOrganisation($id: ID!) {
  getOrganisation(id: $id) {
    id
    subdomain
    name
    logoBase64
    primaryColor
    secondaryColor
    owner
    email
    users {
      items {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.listOrganisations = `query ListOrganisations(
  $filter: ModelOrganisationFilterInput
  $limit: Int
  $nextToken: String
) {
  listOrganisations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      subdomain
      name
      logoBase64
      primaryColor
      secondaryColor
      owner
      email
      users {
        items {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getApiKey = `query GetApiKey($key: String!) {
  getApiKey(key: $key) {
    key
    address
    user {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.listApiKeys = `query ListApiKeys(
  $key: String
  $filter: ModelApiKeyFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listApiKeys(
    key: $key
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      key
      address
      user {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getWebhook = `query GetWebhook($id: ID!) {
  getWebhook(id: $id) {
    id
    url
    address
    user {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.listWebhooks = `query ListWebhooks(
  $id: ID
  $filter: ModelWebhookFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listWebhooks(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      url
      address
      user {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getWebhookLog = `query GetWebhookLog($id: ID!) {
  getWebhookLog(id: $id) {
    id
    url
    address
    event
    requestBody
    responseBody
    responseStatusCode
    createdAt
    deliveryStatus
    updatedAt
    __typename
  }
}
`;
exports.listWebhookLogs = `query ListWebhookLogs(
  $id: ID
  $filter: ModelWebhookLogFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listWebhookLogs(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      url
      address
      event
      requestBody
      responseBody
      responseStatusCode
      createdAt
      deliveryStatus
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.getKeyMetric = `query GetKeyMetric($id: ID!) {
  getKeyMetric(id: $id) {
    available_funds
    createdAt
    daily_arweave_uploads
    daily_audio_uploads
    daily_audio_uploads_size
    daily_banned_uploads
    daily_blocked_uploads
    daily_churn
    daily_cloud_uploads
    daily_committed_storage
    daily_committed_uploads
    daily_committed_uploads_duration
    daily_documents_uploads
    daily_documents_uploads_size
    daily_expenses_eur
    daily_invites_accepted
    daily_invites_sent
    daily_ipfs_uploads
    daily_memos
    daily_new_users
    daily_other_uploads
    daily_other_uploads_size
    daily_payments
    daily_pending_uploads
    daily_photos_uploads
    daily_photos_uploads_size
    daily_rejected_uploads
    daily_reposted_twice_uploads
    daily_reposted_uploads
    daily_revenue_eur
    daily_scheduled_uploads
    daily_transactions
    daily_uploads
    daily_uploads_size
    daily_used_storage
    daily_users_activity {
      location
      users_count
      __typename
    }
    daily_vaults
    daily_video_uploads
    daily_video_uploads_size
    date
    id
    monthly_active_users_count
    monthly_active_users_list
    total_active_users
    total_arweave_uploads
    total_audio_uploads
    total_audio_uploads_size
    total_banned_uploads
    total_blocked_uploads
    total_cloud_uploads
    total_committed_storage
    total_committed_uploads
    total_documents_uploads
    total_documents_uploads_size
    total_expenses_eur
    total_inactive_users
    total_invites_sent
    total_invites_unaccepted
    total_ipfs_uploads
    total_memos
    total_other_uploads
    total_other_uploads_size
    total_payments
    total_pending_uploads
    total_photos_uploads
    total_photos_uploads_size
    total_rejected_uploads
    total_reposted_twice_uploads
    total_reposted_uploads
    total_revenue_eur
    total_scheduled_uploads
    total_transactions
    total_uploads
    total_uploads_size
    total_used_storage
    total_vaults
    total_video_uploads
    total_video_uploads_size
    updatedAt
    __typename
  }
}
`;
exports.listKeyMetrics = `query ListKeyMetrics(
  $filter: ModelKeyMetricFilterInput
  $limit: Int
  $nextToken: String
) {
  listKeyMetrics(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      available_funds
      createdAt
      daily_arweave_uploads
      daily_audio_uploads
      daily_audio_uploads_size
      daily_banned_uploads
      daily_blocked_uploads
      daily_churn
      daily_cloud_uploads
      daily_committed_storage
      daily_committed_uploads
      daily_committed_uploads_duration
      daily_documents_uploads
      daily_documents_uploads_size
      daily_expenses_eur
      daily_invites_accepted
      daily_invites_sent
      daily_ipfs_uploads
      daily_memos
      daily_new_users
      daily_other_uploads
      daily_other_uploads_size
      daily_payments
      daily_pending_uploads
      daily_photos_uploads
      daily_photos_uploads_size
      daily_rejected_uploads
      daily_reposted_twice_uploads
      daily_reposted_uploads
      daily_revenue_eur
      daily_scheduled_uploads
      daily_transactions
      daily_uploads
      daily_uploads_size
      daily_used_storage
      daily_users_activity {
        location
        users_count
        __typename
      }
      daily_vaults
      daily_video_uploads
      daily_video_uploads_size
      date
      id
      monthly_active_users_count
      monthly_active_users_list
      total_active_users
      total_arweave_uploads
      total_audio_uploads
      total_audio_uploads_size
      total_banned_uploads
      total_blocked_uploads
      total_cloud_uploads
      total_committed_storage
      total_committed_uploads
      total_documents_uploads
      total_documents_uploads_size
      total_expenses_eur
      total_inactive_users
      total_invites_sent
      total_invites_unaccepted
      total_ipfs_uploads
      total_memos
      total_other_uploads
      total_other_uploads_size
      total_payments
      total_pending_uploads
      total_photos_uploads
      total_photos_uploads_size
      total_rejected_uploads
      total_reposted_twice_uploads
      total_reposted_uploads
      total_revenue_eur
      total_scheduled_uploads
      total_transactions
      total_uploads
      total_uploads_size
      total_used_storage
      total_vaults
      total_video_uploads
      total_video_uploads_size
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.membershipsByAddress = `query MembershipsByAddress(
  $address: String!
  $sortDirection: ModelSortDirection
  $filter: ModelMembershipFilterInput
  $limit: Int
  $nextToken: String
) {
  membershipsByAddress(
    address: $address
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      address
      email
      vaultId
      vault {
        id
        membership {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        admin
        data
        description
        name
        owner
        public
        cloud
        blocked
        size
        status
        tags
        termsOfAccess
        createdAt
        updatedAt
        __typename
      }
      memberDetails {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      data
      expiresAt
      _ttl
      keys {
        encPrivateKey
        encPublicKey
        publicKey
        __typename
      }
      encPublicSigningKey
      message
      owner
      role
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.membershipsByEmail = `query MembershipsByEmail(
  $email: String!
  $sortDirection: ModelSortDirection
  $filter: ModelMembershipFilterInput
  $limit: Int
  $nextToken: String
) {
  membershipsByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      address
      email
      vaultId
      vault {
        id
        membership {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        admin
        data
        description
        name
        owner
        public
        cloud
        blocked
        size
        status
        tags
        termsOfAccess
        createdAt
        updatedAt
        __typename
      }
      memberDetails {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      data
      expiresAt
      _ttl
      keys {
        encPrivateKey
        encPublicKey
        publicKey
        __typename
      }
      encPublicSigningKey
      message
      owner
      role
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.membershipsByVaultId = `query MembershipsByVaultId(
  $vaultId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelMembershipFilterInput
  $limit: Int
  $nextToken: String
) {
  membershipsByVaultId(
    vaultId: $vaultId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      address
      email
      vaultId
      vault {
        id
        membership {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        admin
        data
        description
        name
        owner
        public
        cloud
        blocked
        size
        status
        tags
        termsOfAccess
        createdAt
        updatedAt
        __typename
      }
      memberDetails {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      data
      expiresAt
      _ttl
      keys {
        encPrivateKey
        encPublicKey
        publicKey
        __typename
      }
      encPublicSigningKey
      message
      owner
      role
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.stacksByVaultId = `query StacksByVaultId(
  $vaultId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelStackFilterInput
  $limit: Int
  $nextToken: String
) {
  stacksByVaultId(
    vaultId: $vaultId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      versions {
        items {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      vaultId
      parentId
      name
      owner
      status
      data
      tags
      size
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.stacksByParentId = `query StacksByParentId(
  $parentId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelStackFilterInput
  $limit: Int
  $nextToken: String
) {
  stacksByParentId(
    parentId: $parentId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      versions {
        items {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      vaultId
      parentId
      name
      owner
      status
      data
      tags
      size
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.nFTSByVaultIdAndName = `query NFTSByVaultIdAndName(
  $vaultId: ID!
  $name: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNFTFilterInput
  $limit: Int
  $nextToken: String
) {
  nFTSByVaultIdAndName(
    vaultId: $vaultId
    name: $name
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      vaultId
      parentId
      name
      owner
      assetId
      asset {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      thumbnailId
      thumbnail {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      balances
      claimable {
        from
        qty
        to
        txID
        __typename
      }
      creator
      ticker
      description
      collection
      data
      status
      tags
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.nFTSByParentIdAndName = `query NFTSByParentIdAndName(
  $parentId: ID!
  $name: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNFTFilterInput
  $limit: Int
  $nextToken: String
) {
  nFTSByParentIdAndName(
    parentId: $parentId
    name: $name
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      vaultId
      parentId
      name
      owner
      assetId
      asset {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      thumbnailId
      thumbnail {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      balances
      claimable {
        from
        qty
        to
        txID
        __typename
      }
      creator
      ticker
      description
      collection
      data
      status
      tags
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.collectionsByVaultId = `query CollectionsByVaultId(
  $vaultId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelCollectionFilterInput
  $limit: Int
  $nextToken: String
) {
  collectionsByVaultId(
    vaultId: $vaultId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      vaultId
      parentId
      name
      description
      owner
      bannerId
      banner {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      thumbnailId
      thumbnail {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      code
      creator
      items
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      data
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.collectionsByParentId = `query CollectionsByParentId(
  $parentId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelCollectionFilterInput
  $limit: Int
  $nextToken: String
) {
  collectionsByParentId(
    parentId: $parentId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      vaultId
      parentId
      name
      description
      owner
      bannerId
      banner {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      thumbnailId
      thumbnail {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      code
      creator
      items
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      data
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.fileVersionsByNodeIdAndCreatedAt = `query FileVersionsByNodeIdAndCreatedAt(
  $nodeId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFileVersionFilterInput
  $limit: Int
  $nextToken: String
) {
  fileVersionsByNodeIdAndCreatedAt(
    nodeId: $nodeId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.fileVersionsByOwnerAndCreatedAt = `query FileVersionsByOwnerAndCreatedAt(
  $owner: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFileVersionFilterInput
  $limit: Int
  $nextToken: String
) {
  fileVersionsByOwnerAndCreatedAt(
    owner: $owner
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.foldersByVaultId = `query FoldersByVaultId(
  $vaultId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelFolderFilterInput
  $limit: Int
  $nextToken: String
) {
  foldersByVaultId(
    vaultId: $vaultId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      vaultId
      parentId
      data
      name
      owner
      size
      status
      tags
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.foldersByParentId = `query FoldersByParentId(
  $parentId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelFolderFilterInput
  $limit: Int
  $nextToken: String
) {
  foldersByParentId(
    parentId: $parentId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      vaultId
      parentId
      data
      name
      owner
      size
      status
      tags
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.memosByVaultId = `query MemosByVaultId(
  $vaultId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelMemoFilterInput
  $limit: Int
  $nextToken: String
) {
  memosByVaultId(
    vaultId: $vaultId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      vaultId
      data
      owner
      status
      versions {
        message
        owner
        reactions {
          owner
          reaction
          createdAt
          __typename
        }
        attachments
        createdAt
        __typename
      }
      parentId
      tags
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.whitelistsByVaultId = `query WhitelistsByVaultId(
  $vaultId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelWhitelistFilterInput
  $limit: Int
  $nextToken: String
) {
  whitelistsByVaultId(
    vaultId: $vaultId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      vaultId
      owner
      type
      token
      capacity
      access
      members {
        address
        email
        externalAddress
        __typename
      }
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.whitelistsByOwner = `query WhitelistsByOwner(
  $owner: String!
  $sortDirection: ModelSortDirection
  $filter: ModelWhitelistFilterInput
  $limit: Int
  $nextToken: String
) {
  whitelistsByOwner(
    owner: $owner
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      vaultId
      owner
      type
      token
      capacity
      access
      members {
        address
        email
        externalAddress
        __typename
      }
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.bundlesByTxId = `query BundlesByTxId(
  $txId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelBundleFilterInput
  $limit: Int
  $nextToken: String
) {
  bundlesByTxId(
    txId: $txId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      txId
      txFee
      status
      dataItem {
        items {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      uploadCount
      dataItemsCount
      size
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.bundlesByStatusAndCreatedAt = `query BundlesByStatusAndCreatedAt(
  $status: BundleStatus!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelBundleFilterInput
  $limit: Int
  $nextToken: String
) {
  bundlesByStatusAndCreatedAt(
    status: $status
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      txId
      txFee
      status
      dataItem {
        items {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      uploadCount
      dataItemsCount
      size
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.storageTransactionsByOwnerAndCreatedAt = `query StorageTransactionsByOwnerAndCreatedAt(
  $owner: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelStorageTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  storageTransactionsByOwnerAndCreatedAt(
    owner: $owner
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      txId
      txFee
      dataItemId
      fileVersion {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      bundleId
      bundle {
        id
        txId
        txFee
        status
        dataItem {
          items {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        uploadCount
        dataItemsCount
        size
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      members {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      class
      vaultId
      nodeId
      nodeType
      status
      type
      uploadCount
      size
      verificationId
      verificationCount
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.storageTransactionsByTxId = `query StorageTransactionsByTxId(
  $txId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelStorageTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  storageTransactionsByTxId(
    txId: $txId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      txId
      txFee
      dataItemId
      fileVersion {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      bundleId
      bundle {
        id
        txId
        txFee
        status
        dataItem {
          items {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        uploadCount
        dataItemsCount
        size
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      members {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      class
      vaultId
      nodeId
      nodeType
      status
      type
      uploadCount
      size
      verificationId
      verificationCount
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.storageTransactionsByDataItemId = `query StorageTransactionsByDataItemId(
  $dataItemId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelStorageTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  storageTransactionsByDataItemId(
    dataItemId: $dataItemId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      txId
      txFee
      dataItemId
      fileVersion {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      bundleId
      bundle {
        id
        txId
        txFee
        status
        dataItem {
          items {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        uploadCount
        dataItemsCount
        size
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      members {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      class
      vaultId
      nodeId
      nodeType
      status
      type
      uploadCount
      size
      verificationId
      verificationCount
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.storageTransactionsByBundleId = `query StorageTransactionsByBundleId(
  $bundleId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelStorageTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  storageTransactionsByBundleId(
    bundleId: $bundleId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      txId
      txFee
      dataItemId
      fileVersion {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      bundleId
      bundle {
        id
        txId
        txFee
        status
        dataItem {
          items {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        uploadCount
        dataItemsCount
        size
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      members {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      class
      vaultId
      nodeId
      nodeType
      status
      type
      uploadCount
      size
      verificationId
      verificationCount
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.storageTransactionsByStatusAndCreatedAt = `query StorageTransactionsByStatusAndCreatedAt(
  $status: StorageTransactionStatus!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelStorageTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  storageTransactionsByStatusAndCreatedAt(
    status: $status
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      txId
      txFee
      dataItemId
      fileVersion {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      bundleId
      bundle {
        id
        txId
        txFee
        status
        dataItem {
          items {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        uploadCount
        dataItemsCount
        size
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      members {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      class
      vaultId
      nodeId
      nodeType
      status
      type
      uploadCount
      size
      verificationId
      verificationCount
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.transactionsByVaultId = `query TransactionsByVaultId(
  $vaultId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  transactionsByVaultId(
    vaultId: $vaultId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      txId
      function
      owner
      vaultId
      actionRef
      groupRef
      objectId
      objectType
      data
      input
      referrer
      status
      tags
      cloud
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.transactionLogsByOwner = `query TransactionLogsByOwner(
  $owner: String!
  $sortDirection: ModelSortDirection
  $filter: ModelTransactionLogFilterInput
  $limit: Int
  $nextToken: String
) {
  transactionLogsByOwner(
    owner: $owner
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      actionRef
      admin
      content
      vaultId
      groupRef
      hash
      objectId
      objectType
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.notificationsByToAddressAndUpdatedAt = `query NotificationsByToAddressAndUpdatedAt(
  $toAddress: String!
  $updatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  notificationsByToAddressAndUpdatedAt(
    toAddress: $toAddress
    updatedAt: $updatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      fromAddress
      from {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      toAddress
      to {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      toMemberId
      toMember {
        id
        address
        email
        vaultId
        vault {
          id
          membership {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          admin
          data
          description
          name
          owner
          public
          cloud
          blocked
          size
          status
          tags
          termsOfAccess
          createdAt
          updatedAt
          __typename
        }
        memberDetails {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        data
        expiresAt
        _ttl
        keys {
          encPrivateKey
          encPublicKey
          publicKey
          __typename
        }
        encPublicSigningKey
        message
        owner
        role
        status
        createdAt
        updatedAt
        __typename
      }
      toEmail
      vaultId
      vault {
        id
        membership {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        admin
        data
        description
        name
        owner
        public
        cloud
        blocked
        size
        status
        tags
        termsOfAccess
        createdAt
        updatedAt
        __typename
      }
      objectId
      objectType
      objectName
      event
      channels
      content
      status
      priority
      activity
      admin
      count
      host
      _ttl
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.usersByEmail = `query UsersByEmail(
  $email: String!
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.usersByReferralId = `query UsersByReferralId(
  $referralId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByReferralId(
    referralId: $referralId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.usersByOrgId = `query UsersByOrgId(
  $orgId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByOrgId(
    orgId: $orgId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.paymentTransactionsByStatusAndCreatedAt = `query PaymentTransactionsByStatusAndCreatedAt(
  $status: PaymentStatus!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPaymentTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  paymentTransactionsByStatusAndCreatedAt(
    status: $status
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      cart {
        amount
        currency
        priceId
        productId
        promo
        storage
        __typename
      }
      createdAt
      invoiceNumber
      paidAt
      paymentIntentId
      owner
      receiptNumber
      status
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.organisationsBySubdomain = `query OrganisationsBySubdomain(
  $subdomain: String!
  $sortDirection: ModelSortDirection
  $filter: ModelOrganisationFilterInput
  $limit: Int
  $nextToken: String
) {
  organisationsBySubdomain(
    subdomain: $subdomain
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subdomain
      name
      logoBase64
      primaryColor
      secondaryColor
      owner
      email
      users {
        items {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.organisationsByOwner = `query OrganisationsByOwner(
  $owner: String!
  $sortDirection: ModelSortDirection
  $filter: ModelOrganisationFilterInput
  $limit: Int
  $nextToken: String
) {
  organisationsByOwner(
    owner: $owner
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subdomain
      name
      logoBase64
      primaryColor
      secondaryColor
      owner
      email
      users {
        items {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.organisationsByEmail = `query OrganisationsByEmail(
  $email: String!
  $sortDirection: ModelSortDirection
  $filter: ModelOrganisationFilterInput
  $limit: Int
  $nextToken: String
) {
  organisationsByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subdomain
      name
      logoBase64
      primaryColor
      secondaryColor
      owner
      email
      users {
        items {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.webhookLogsByAddressAndCreatedAt = `query WebhookLogsByAddressAndCreatedAt(
  $address: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelWebhookLogFilterInput
  $limit: Int
  $nextToken: String
) {
  webhookLogsByAddressAndCreatedAt(
    address: $address
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      url
      address
      event
      requestBody
      responseBody
      responseStatusCode
      createdAt
      deliveryStatus
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
exports.keyMetricsByDate = `query KeyMetricsByDate(
  $date: AWSDate!
  $sortDirection: ModelSortDirection
  $filter: ModelKeyMetricFilterInput
  $limit: Int
  $nextToken: String
) {
  keyMetricsByDate(
    date: $date
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      available_funds
      createdAt
      daily_arweave_uploads
      daily_audio_uploads
      daily_audio_uploads_size
      daily_banned_uploads
      daily_blocked_uploads
      daily_churn
      daily_cloud_uploads
      daily_committed_storage
      daily_committed_uploads
      daily_committed_uploads_duration
      daily_documents_uploads
      daily_documents_uploads_size
      daily_expenses_eur
      daily_invites_accepted
      daily_invites_sent
      daily_ipfs_uploads
      daily_memos
      daily_new_users
      daily_other_uploads
      daily_other_uploads_size
      daily_payments
      daily_pending_uploads
      daily_photos_uploads
      daily_photos_uploads_size
      daily_rejected_uploads
      daily_reposted_twice_uploads
      daily_reposted_uploads
      daily_revenue_eur
      daily_scheduled_uploads
      daily_transactions
      daily_uploads
      daily_uploads_size
      daily_used_storage
      daily_users_activity {
        location
        users_count
        __typename
      }
      daily_vaults
      daily_video_uploads
      daily_video_uploads_size
      date
      id
      monthly_active_users_count
      monthly_active_users_list
      total_active_users
      total_arweave_uploads
      total_audio_uploads
      total_audio_uploads_size
      total_banned_uploads
      total_blocked_uploads
      total_cloud_uploads
      total_committed_storage
      total_committed_uploads
      total_documents_uploads
      total_documents_uploads_size
      total_expenses_eur
      total_inactive_users
      total_invites_sent
      total_invites_unaccepted
      total_ipfs_uploads
      total_memos
      total_other_uploads
      total_other_uploads_size
      total_payments
      total_pending_uploads
      total_photos_uploads
      total_photos_uploads_size
      total_rejected_uploads
      total_reposted_twice_uploads
      total_reposted_uploads
      total_revenue_eur
      total_scheduled_uploads
      total_transactions
      total_uploads
      total_uploads_size
      total_used_storage
      total_vaults
      total_video_uploads
      total_video_uploads_size
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`;
